<!-- Classes main-div and example-card are catagorized in .css file -->
<div class="login-header">
  <div class="language-item row">
    <a class="nav-link vt-cursor-pointer" (click)="onChangeLanguage('vi')"
       [matTooltip]="'header.vietnamese' | translate"><img class="vt-cursor-pointer" src="./assets/images/vietnam.png"
                                                           alt="vietnamese"></a>
    <a class="nav-link vt-cursor-pointer" (click)="onChangeLanguage('en')"
       [matTooltip]="'header.english' | translate"><img class="vt-cursor-pointer"
                                                        src="./assets/images/united-kingdom.png" alt="english"></a>
  </div>
</div>
<div class="login-wrapper">
  <mat-card class="login-card p-0">
      <div class="text-center title">
        {{'title.reset_password_invalid' | translate}}
      </div>
      <mat-card-content class="pt-2">
        <div class="mt-4 pr-4 pl-4"><strong>{{'title.reset_password_exists' | translate}}</strong></div>
      </mat-card-content>
      <mat-card-actions class="pb-4 text-center pr-4 pl-4">
        <button class="ml-2" mat-stroked-button color="primary" type="button" (click)="cancel()">
          {{'button.cancel' | translate}}
        </button>
        <button mat-raised-button color="primary" type="button" (click)="resendPassword()">
          {{'alert.reset_password' | translate}}
        </button>
      </mat-card-actions>
  </mat-card>
</div>
<div class="login-footer">
  <div class="container-fluid py-3">
    <div class="row">
      <div class="col-12">
        <h5 class="text-white">{{'footer.contact' | translate}}</h5>
      </div>
    </div>
    <div class="row">
      <div class="col-3">
        {{'footer.hot_line' | translate}} 1800-8000
        {{'footer.bran_2' | translate}}<br>{{'footer.email_detail' | translate}}
      </div>
      <div class="col-5">
        {{'footer.text_owner' | translate}}<br>{{'footer.paper' | translate}}
      </div>
      <div class="col-4 text-right">
        {{'footer.copy-right' | translate}}<br>
      </div>
    </div>
  </div>
</div>
